// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Затемнение фона */
.PaymentModal_overlay__4Fvnk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.PaymentModal_confirm__ObAgQ:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Три точки */
.PaymentModal_dots__v9uMk { 
  margin-left: 5px;
  font-size: 22px;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
}

.PaymentModal_dots__v9uMk:hover {
  background: rgba(0, 0, 0, 0.07);
}

/* Контейнер меню (как модалка внутри модалки) */
.PaymentModal_walletMenu__mIVUK {
  position: absolute;
  top: 45px;
  right: 0;
  width: 350px;
  max-height: 420px;
  overflow-y: auto;
  background: #fff;
  border-radius: 14px;
  padding: 15px;
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.23);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  animation: PaymentModal_scaleFade__niYVS 0.18s ease-out;
  z-index: 1000;
}

/* Карточка метода */
.PaymentModal_walletItem__9bYy9 {
  background: #f8f9fa;
  padding: 14px 10px;
  border-radius: 14px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  border: 1px solid #e3e3e3;
  transition: 0.17s ease;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.PaymentModal_walletItem__9bYy9:hover {
  background: #eef1ff;
  border-color: #d2d8ff;
}

/* Маленькие точки под названием */
.PaymentModal_walletItem__9bYy9::after {
  content: "⋮⋮⋮";
  font-size: 12px;
  color: #9aa0a6;
  margin-top: 6px;
  letter-spacing: 2px;
}

/* Анимация появления как в iOS меню */
@keyframes PaymentModal_scaleFade__niYVS {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}


/* Само модальное окно */
.PaymentModal_modal__abjiV {
  background: #fff;
  border-radius: 16px;
  width: 900px;
  height: 600px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

/* Левая колонка */
.PaymentModal_left__BAqgn {
  flex: 0 0 40%;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border-right: 1px solid #ddd;
}

/* Быстрые кнопки */
.PaymentModal_quickBtns__vzL6L {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.PaymentModal_quickBtns__vzL6L button {
  padding: 14px;
  font-size: 18px;
  border-radius: 12px;
  border: none;
  background: #e9ecef;
  cursor: pointer;
  transition: 0.2s;
}
.PaymentModal_quickBtns__vzL6L button:hover {
  background: #dee2e6;
}

/* Нумпад */
.PaymentModal_numPad__bmwQg {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 20px;
}
.PaymentModal_numPad__bmwQg button {
  padding: 20px;
  font-size: 20px;
  border-radius: 12px;
  border: none;
  background: #f1f3f5;
  cursor: pointer;
  transition: 0.2s;
}
.PaymentModal_numPad__bmwQg button:hover {
  background: #e9ecef;
}

/* Правая колонка */
.PaymentModal_right__mSzt9 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

/* Табы */
.PaymentModal_tabs__Ch-cD {
  position: relative;
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}
.PaymentModal_tabs__Ch-cD button {
  flex: 1 1;
  padding: 12px;
  border-radius: 12px;
  border: none;
  font-size: 16px;
  background: #f1f3f5;
  cursor: pointer;
  transition: 0.2s;
}
.PaymentModal_tabs__Ch-cD button:hover {
  background: #dee2e6;
}
.PaymentModal_tabs__Ch-cD .PaymentModal_active__q9TjS {
  background: #000;
  color: #fff;
}

/* Список оплат */
.PaymentModal_payments__\\+JONu {
  flex: 1 1;
  overflow-y: auto;
  margin-bottom: 15px;
}
.PaymentModal_paymentRow__lUW\\+y {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}
.PaymentModal_paymentRow__lUW\\+y span {
  font-weight: 500;
}
.PaymentModal_paymentRow__lUW\\+y input {
  width: 100px;
  text-align: right;
  padding: 6px;
  border: none;
  background: transparent;
  font-size: 16px;
}
.PaymentModal_paymentRow__lUW\\+y button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* Кнопки действий */
.PaymentModal_actions__EglVC {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}
.PaymentModal_actions__EglVC button {
  flex: 1 1;
  padding: 10px;
  border: none;
  border-radius: 10px;
  background: #e9ecef;
  cursor: pointer;
  transition: 0.2s;
}
.PaymentModal_actions__EglVC button:hover {
  background: #dee2e6;
}

/* Комментарий */
textarea {
  resize: none;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  min-height: 60px;
  margin-bottom: 15px;
  font-size: 14px;
  outline: none;
}

/* Итог */
.PaymentModal_summary__z\\+188 {
  font-size: 16px;
  margin-bottom: 15px;
}
.PaymentModal_summary__z\\+188 p {
  margin: 4px 0;
}
.PaymentModal_summary__z\\+188 strong {
  font-size: 18px;
}

/* Кнопка выбить чек */
.PaymentModal_confirm__ObAgQ {
  background: rgba(24, 115, 70, 1);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px;
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: 0.2s;
}
.PaymentModal_confirm__ObAgQ:hover {
  background: #218838;
}

/* Кнопка закрыть */
.PaymentModal_close__R3YWJ {
  background: black;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: 1s;
}
.PaymentModal_close__R3YWJ:hover {
  background: white;
  color: black;
}

/* ===== DISCOUNT BAR (Скидка на весь чек) ===== */
.PaymentModal_discountWrap__0IItS {
  width: 100%;
  margin: 10px 0 15px;
}

.PaymentModal_discountLabel__PlAn9 {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.PaymentModal_discountRow__YvIi6 {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;

  border: 1px solid #dcdcdc;
  border-radius: 10px;
  overflow: hidden;

  background: #fff;
}

.PaymentModal_discountInput__NTzhp {
  flex: 1 1;
  height: 100%;
  border: none;
  outline: none;

  padding: 0 14px;
  font-size: 16px;
  color: #111;
}

.PaymentModal_discountBtn__tovhl {
  width: 48px;
  height: 100%;
  border: none;
  cursor: pointer;

  background: #fff;
  border-left: 1px solid #e7e7e7;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 700;
  color: #444;

  transition: 0.15s ease;
}

.PaymentModal_discountBtn__tovhl:hover {
  background: #f5f5f5;
}

.PaymentModal_discountBtnActive__wX2hc {
  background: #f1f7ff;
  color: #1f6feb;
}

.PaymentModal_discountClose__mxjXE {
  width: 48px;
  height: 100%;
  border: none;
  cursor: pointer;

  background: #fff;
  border-left: 1px solid #e7e7e7;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 18px;
  font-weight: 800;
  color: #d11;

  transition: 0.15s ease;
}

.PaymentModal_discountClose__mxjXE:hover {
  background: #fff1f1;
}

/* ===== quality fixes ===== */

/* активная строка оплаты (если используешь styles.activeRow) */
.PaymentModal_activeRow__QHpWV {
  border: 1px solid rgba(24, 115, 70, 0.6);
  box-shadow: 0 0 0 2px rgba(24, 115, 70, 0.12);
}

/* чтобы инпут суммы был более аккуратный */
.PaymentModal_paymentRow__lUW\\+y input {
  outline: none;
  border-radius: 8px;
}

/* ВАЖНО: textarea только внутри модалки, а не глобально */
.PaymentModal_right__mSzt9 textarea {
  resize: none;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  min-height: 60px;
  margin-bottom: 15px;
  font-size: 14px;
  outline: none;
}
.PaymentModal_right__mSzt9 textarea:focus {
  border-color: rgba(24, 115, 70, 0.6);
  box-shadow: 0 0 0 2px rgba(24, 115, 70, 0.12);
}

`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/PaymentModal.module.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,qCAAqC;EACrC,SAAS;;EAET,uDAAmC;EACnC,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;;AAGA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA,SAAS;AACT;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;;EAEnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;;EAEhB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;;EAEb,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;;EAEf,gBAAgB;EAChB,8BAA8B;;EAE9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,WAAW;;EAEX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;;EAEf,gBAAgB;EAChB,8BAA8B;;EAE9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,WAAW;;EAEX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;;AAE9B,+DAA+D;AAC/D;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C","sourcesContent":["/* Затемнение фона */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Три точки */\n.dots { \n  margin-left: 5px;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  transition: 0.15s ease;\n  user-select: none;\n}\n\n.dots:hover {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n/* Контейнер меню (как модалка внутри модалки) */\n.walletMenu {\n  position: absolute;\n  top: 45px;\n  right: 0;\n  width: 350px;\n  max-height: 420px;\n  overflow-y: auto;\n  background: #fff;\n  border-radius: 14px;\n  padding: 15px;\n  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.23);\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n\n  animation: scaleFade 0.18s ease-out;\n  z-index: 1000;\n}\n\n/* Карточка метода */\n.walletItem {\n  background: #f8f9fa;\n  padding: 14px 10px;\n  border-radius: 14px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  border: 1px solid #e3e3e3;\n  transition: 0.17s ease;\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.walletItem:hover {\n  background: #eef1ff;\n  border-color: #d2d8ff;\n}\n\n/* Маленькие точки под названием */\n.walletItem::after {\n  content: \"⋮⋮⋮\";\n  font-size: 12px;\n  color: #9aa0a6;\n  margin-top: 6px;\n  letter-spacing: 2px;\n}\n\n/* Анимация появления как в iOS меню */\n@keyframes scaleFade {\n  from {\n    opacity: 0;\n    transform: translateY(6px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n\n/* Само модальное окно */\n.modal {\n  background: #fff;\n  border-radius: 16px;\n  width: 900px;\n  height: 600px;\n  display: flex;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n}\n\n/* Левая колонка */\n.left {\n  flex: 0 0 40%;\n  background: #f8f9fa;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  border-right: 1px solid #ddd;\n}\n\n/* Быстрые кнопки */\n.quickBtns {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n.quickBtns button {\n  padding: 14px;\n  font-size: 18px;\n  border-radius: 12px;\n  border: none;\n  background: #e9ecef;\n  cursor: pointer;\n  transition: 0.2s;\n}\n.quickBtns button:hover {\n  background: #dee2e6;\n}\n\n/* Нумпад */\n.numPad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-top: 20px;\n}\n.numPad button {\n  padding: 20px;\n  font-size: 20px;\n  border-radius: 12px;\n  border: none;\n  background: #f1f3f5;\n  cursor: pointer;\n  transition: 0.2s;\n}\n.numPad button:hover {\n  background: #e9ecef;\n}\n\n/* Правая колонка */\n.right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n/* Табы */\n.tabs {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n.tabs button {\n  flex: 1;\n  padding: 12px;\n  border-radius: 12px;\n  border: none;\n  font-size: 16px;\n  background: #f1f3f5;\n  cursor: pointer;\n  transition: 0.2s;\n}\n.tabs button:hover {\n  background: #dee2e6;\n}\n.tabs .active {\n  background: #000;\n  color: #fff;\n}\n\n/* Список оплат */\n.payments {\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 15px;\n}\n.paymentRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n.paymentRow span {\n  font-weight: 500;\n}\n.paymentRow input {\n  width: 100px;\n  text-align: right;\n  padding: 6px;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n}\n.paymentRow button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* Кнопки действий */\n.actions {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n.actions button {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  background: #e9ecef;\n  cursor: pointer;\n  transition: 0.2s;\n}\n.actions button:hover {\n  background: #dee2e6;\n}\n\n/* Комментарий */\ntextarea {\n  resize: none;\n  border-radius: 10px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  min-height: 60px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  outline: none;\n}\n\n/* Итог */\n.summary {\n  font-size: 16px;\n  margin-bottom: 15px;\n}\n.summary p {\n  margin: 4px 0;\n}\n.summary strong {\n  font-size: 18px;\n}\n\n/* Кнопка выбить чек */\n.confirm {\n  background: rgba(24, 115, 70, 1);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 14px;\n  font-size: 18px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: 0.2s;\n}\n.confirm:hover {\n  background: #218838;\n}\n\n/* Кнопка закрыть */\n.close {\n  background: black;\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: 1s;\n}\n.close:hover {\n  background: white;\n  color: black;\n}\n\n/* ===== DISCOUNT BAR (Скидка на весь чек) ===== */\n.discountWrap {\n  width: 100%;\n  margin: 10px 0 15px;\n}\n\n.discountLabel {\n  font-size: 12px;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.discountRow {\n  width: 100%;\n  height: 44px;\n  display: flex;\n  align-items: center;\n\n  border: 1px solid #dcdcdc;\n  border-radius: 10px;\n  overflow: hidden;\n\n  background: #fff;\n}\n\n.discountInput {\n  flex: 1;\n  height: 100%;\n  border: none;\n  outline: none;\n\n  padding: 0 14px;\n  font-size: 16px;\n  color: #111;\n}\n\n.discountBtn {\n  width: 48px;\n  height: 100%;\n  border: none;\n  cursor: pointer;\n\n  background: #fff;\n  border-left: 1px solid #e7e7e7;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 16px;\n  font-weight: 700;\n  color: #444;\n\n  transition: 0.15s ease;\n}\n\n.discountBtn:hover {\n  background: #f5f5f5;\n}\n\n.discountBtnActive {\n  background: #f1f7ff;\n  color: #1f6feb;\n}\n\n.discountClose {\n  width: 48px;\n  height: 100%;\n  border: none;\n  cursor: pointer;\n\n  background: #fff;\n  border-left: 1px solid #e7e7e7;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 18px;\n  font-weight: 800;\n  color: #d11;\n\n  transition: 0.15s ease;\n}\n\n.discountClose:hover {\n  background: #fff1f1;\n}\n\n/* ===== quality fixes ===== */\n\n/* активная строка оплаты (если используешь styles.activeRow) */\n.activeRow {\n  border: 1px solid rgba(24, 115, 70, 0.6);\n  box-shadow: 0 0 0 2px rgba(24, 115, 70, 0.12);\n}\n\n/* чтобы инпут суммы был более аккуратный */\n.paymentRow input {\n  outline: none;\n  border-radius: 8px;\n}\n\n/* ВАЖНО: textarea только внутри модалки, а не глобально */\n.right textarea {\n  resize: none;\n  border-radius: 10px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  min-height: 60px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  outline: none;\n}\n.right textarea:focus {\n  border-color: rgba(24, 115, 70, 0.6);\n  box-shadow: 0 0 0 2px rgba(24, 115, 70, 0.12);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `PaymentModal_overlay__4Fvnk`,
	"confirm": `PaymentModal_confirm__ObAgQ`,
	"dots": `PaymentModal_dots__v9uMk`,
	"walletMenu": `PaymentModal_walletMenu__mIVUK`,
	"scaleFade": `PaymentModal_scaleFade__niYVS`,
	"walletItem": `PaymentModal_walletItem__9bYy9`,
	"modal": `PaymentModal_modal__abjiV`,
	"left": `PaymentModal_left__BAqgn`,
	"quickBtns": `PaymentModal_quickBtns__vzL6L`,
	"numPad": `PaymentModal_numPad__bmwQg`,
	"right": `PaymentModal_right__mSzt9`,
	"tabs": `PaymentModal_tabs__Ch-cD`,
	"active": `PaymentModal_active__q9TjS`,
	"payments": `PaymentModal_payments__+JONu`,
	"paymentRow": `PaymentModal_paymentRow__lUW+y`,
	"actions": `PaymentModal_actions__EglVC`,
	"summary": `PaymentModal_summary__z+188`,
	"close": `PaymentModal_close__R3YWJ`,
	"discountWrap": `PaymentModal_discountWrap__0IItS`,
	"discountLabel": `PaymentModal_discountLabel__PlAn9`,
	"discountRow": `PaymentModal_discountRow__YvIi6`,
	"discountInput": `PaymentModal_discountInput__NTzhp`,
	"discountBtn": `PaymentModal_discountBtn__tovhl`,
	"discountBtnActive": `PaymentModal_discountBtnActive__wX2hc`,
	"discountClose": `PaymentModal_discountClose__mxjXE`,
	"activeRow": `PaymentModal_activeRow__QHpWV`
};
export default ___CSS_LOADER_EXPORT___;
